// ═══════════════════════════════════════════════════════════════════════════
// File System Access API + IndexedDB
// Extraído VERBATIM de index.html v0.9.16.
// ═══════════════════════════════════════════════════════════════════════════
//
// Guarda un handle al archivo JSON de respaldo que elige el usuario.
// Solo navegador: no tiene prueba unitaria.



export const FILE_SYSTEM_SUPPORTED = 'showOpenFilePicker' in window;

export function openHandleDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open("VinicolaTotalDB", 1);
    req.onupgradeneeded = () => req.result.createObjectStore("handles");
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function storeHandle(handle) {
  const db = await openHandleDB();
  const tx = db.transaction("handles", "readwrite");
  tx.objectStore("handles").put(handle, "dataFile");
  return new Promise((res, rej) => { tx.oncomplete = res; tx.onerror = rej; });
}

export async function getStoredHandle() {
  const db = await openHandleDB();
  const tx = db.transaction("handles", "readonly");
  const req = tx.objectStore("handles").get("dataFile");
  return new Promise((res) => { req.onsuccess = () => res(req.result || null); req.onerror = () => res(null); });
}

export async function clearStoredHandle() {
  const db = await openHandleDB();
  const tx = db.transaction("handles", "readwrite");
  tx.objectStore("handles").delete("dataFile");
}

export async function readFromFile(handle) {
  try {
    const perm = await handle.queryPermission({ mode: "readwrite" });
    if (perm !== "granted") {
      const req = await handle.requestPermission({ mode: "readwrite" });
      if (req !== "granted") return null;
    }
    const file = await handle.getFile();
    const text = await file.text();
    if (!text.trim()) return null;
    return JSON.parse(text);
  } catch (e) { console.warn("Read error:", e); return null; }
}

export async function writeToFile(handle, data) {
  try {
    const perm = await handle.queryPermission({ mode: "readwrite" });
    if (perm !== "granted") return false;
    const writable = await handle.createWritable();
    await writable.write(JSON.stringify(data, null, 2));
    await writable.close();
    return true;
  } catch (e) { console.warn("Write error:", e); return false; }
}

export async function pickDataFile() {
  try {
    const [handle] = await window.showOpenFilePicker({
      types: [{ description: "Datos Vinícola Total", accept: { "application/json": [".json"] } }],
      multiple: false,
    });
    await storeHandle(handle);
    return handle;
  } catch (e) {
    if (e.name === "AbortError") return null;
    throw e;
  }
}

export async function createDataFile() {
  try {
    const handle = await window.showSaveFilePicker({
      suggestedName: "vinicola-total-datos.json",
      types: [{ description: "Datos Vinícola Total", accept: { "application/json": [".json"] } }],
    });
    await storeHandle(handle);
    return handle;
  } catch (e) {
    if (e.name === "AbortError") return null;
    throw e;
  }
}
